export default {
      id: "undo-usage",
      viewBox: "0 0 18 18",
      url: "/" + "img/marilyn-ui.svg#undo",
      toString: function () {
        return this.url;
      }
    }